"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertSuccess = exports.AlertError = exports.AlertInfo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var AlertTitle_1 = __importDefault(require("@mui/material/AlertTitle"));
var styles_1 = require("@mui/material/styles");
var InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
var CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
var StyledAlertBase = (0, styles_1.styled)(Alert_1.default)(function () { return ({
    alignItems: "center",
    borderRadius: "4px",
    padding: "12px 16px 12px 8px",
    "& .MuiAlert-icon": {
        marginRight: "8px",
        padding: "0",
    },
    "& .MuiAlert-icon svg": {
        width: "24px",
        height: "24px",
    },
    "& .MuiAlert-message": {
        padding: "0px",
    },
}); });
var StyledAlertInfo = (0, styles_1.styled)(StyledAlertBase)(function () { return ({
    background: "#FCECF4",
    color: "#AF2165",
    "& .MuiAlert-icon": {
        color: "#DD468F",
    },
}); });
var StyledAlertError = (0, styles_1.styled)(StyledAlertBase)(function () { return ({
    background: "#FDEAE9",
    color: "#9F110B",
    "& .MuiAlert-icon": {
        color: "#EA2C24",
    },
}); });
var StyledAlertSuccess = (0, styles_1.styled)(StyledAlertBase)(function () { return ({
    color: "#0B7664",
    "& .MuiAlert-icon": {
        color: "#00A085",
    },
}); });
var StyledAlertTitle = (0, styles_1.styled)(AlertTitle_1.default)(function () { return ({
    fontWeight: "700",
    fontSize: "14px",
    marginTop: 0,
    marginBottom: 0,
    lineHeight: "140%",
}); });
var StyledStack = (0, styles_1.styled)(Stack_1.default)(function () { return ({
    marginTop: "24px",
    width: "100%",
    "& .MuiAlert-message": {
        padding: "2px 0px",
    },
}); });
var AlertInfo = function (_a) {
    var message = _a.message;
    return ((0, jsx_runtime_1.jsx)(StyledStack, { children: (0, jsx_runtime_1.jsx)(StyledAlertInfo, { icon: (0, jsx_runtime_1.jsx)(InfoOutlined_1.default, {}), severity: "info", children: (0, jsx_runtime_1.jsx)(StyledAlertTitle, { children: message }) }) }));
};
exports.AlertInfo = AlertInfo;
var AlertError = function (_a) {
    var message = _a.message;
    return ((0, jsx_runtime_1.jsx)(StyledStack, { children: (0, jsx_runtime_1.jsx)(StyledAlertError, { severity: "error", children: (0, jsx_runtime_1.jsx)(StyledAlertTitle, { children: message }) }) }));
};
exports.AlertError = AlertError;
var AlertSuccess = function (_a) {
    var message = _a.message;
    return ((0, jsx_runtime_1.jsx)(StyledStack, { children: (0, jsx_runtime_1.jsx)(StyledAlertSuccess, { icon: (0, jsx_runtime_1.jsx)(CheckCircleOutline_1.default, {}), severity: "success", children: (0, jsx_runtime_1.jsx)(StyledAlertTitle, { children: message }) }) }));
};
exports.AlertSuccess = AlertSuccess;
